class keyboardShortcuts {

    constructor() {
        this.shortcuts = [];

        window.addEventListener('keydown', (e) => {
            if (e.altKey) {
                e.preventDefault();
                e.stopPropagation();
            }

            for (let shortcut of this.shortcuts) {
                if (shortcut.keys.ctrl === e.ctrlKey &&
                    shortcut.keys.alt === e.altKey &&
                    shortcut.keys.shift === e.shiftKey &&
                    shortcut.keys.key === String(e.key).toUpperCase()) {
                        for(let s of shortcut.method) {
                            let res = s();
                            if (res === false) {
                                e.preventDefault();
                                break;
                            }
                        }
                        return;
                    }
            }
        });
    }

    register(keys, method) {
        let k = {
            ctrl: false,
            alt: false,
            shift: false,
            key: '',
            ...keys
        };

        for (let shortcut of this.shortcuts) {
            if (shortcut.keys.ctrl === k.ctrl &&
                shortcut.keys.alt === k.alt &&
                shortcut.keys.shift === k.shift &&
                shortcut.keys.key === k.key) {
                    shortcut.method = [method, ...shortcut.method];
                    return;
                }
        }

        this.shortcuts.push({keys: k, method: [method]});
    }

    unregister(keys, method) {
        let k = {
            ctrl: false,
            alt: false,
            shift: false,
            key: '',
            ...keys
        };

        for (let shortcut of this.shortcuts) {
            if (shortcut.keys.ctrl === k.ctrl &&
                shortcut.keys.alt === k.alt &&
                shortcut.keys.shift === k.shift &&
                shortcut.keys.key === k.key) {
                    shortcut.method = shortcut.method.filter(m => m !== method);
                    return;
                }
        }
    }

}

let ks = new keyboardShortcuts();
export default ks;